<template>
    <div>
        <app-header></app-header>

        <div class='section'>
            <h1 id="shares-title" class="title is-capitalized has-text-centered">
                Shares
            </h1>
        </div>

        <!-- <share-details
            v-if="!shares_api_loading"
            :share_details="shares"
        >
        </share-details> -->
        <share-details></share-details>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
        },
        mounted() {
        },
    }
</script>

<style scoped lang="scss">
    // this should inherit from App.vue but I dont know how
    $den_offwhite: #dddbd4;

    #shares-title.title {
        color: $den_offwhite;
    }
</style>
